import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useGetMeQuery } from "state/api";
import { syncIdentity } from "state/authSlice";
import { identityPatch } from "state/identitySync";

// Mounted once, app-wide. Asks /me what this person's role and capabilities
// are and reconciles the stored login snapshot with the answer, so an Admin
// promoting someone or switching one of a leader's tabs off reaches their
// screen on the next page view instead of at their next sign-in.
//
// Skipped when nobody is signed in — /me would 401 and there is no snapshot to
// reconcile.
export const useIdentitySync = () => {
  const dispatch = useDispatch();
  const user = useSelector((state) => state.auth.user);
  const token = useSelector((state) => state.auth.token);
  const { data: me } = useGetMeQuery(undefined, { skip: !token });

  useEffect(() => {
    const patch = identityPatch(user, me);
    // identityPatch returns null when nothing differs, which is what stops
    // this dispatching on every render.
    if (patch) dispatch(syncIdentity(patch));
  }, [user, me, dispatch]);
};

export default useIdentitySync;
